import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { BanjoString } from '@stashinvest/react-banjo';
import { Flex } from '@stashinvest/ui/dist/es/2';
import { ButtonStandard, Text } from '@stashinvest/react-components';
import { trackOnSetupResults } from './LinkPlaidEvents';
import { v1_ExternalAccountLinkSetupResults_ViewedProperties } from '@stashinvest/product-events-javascript/lib/v1/properties';

const LinkPlaidTimeout = ({ dismiss, trackEvent, isOnboarding }) => {
	useEffect(() => {
		if (!trackEvent) return;
		trackOnSetupResults(
			isOnboarding,
			trackEvent,
			v1_ExternalAccountLinkSetupResults_ViewedProperties.Result.failure
		);
	}, [trackEvent, isOnboarding]);

	return (
		<Flex flexDirection="column" alignItems="center">
			<Text textStyle="headerSmall" className="mb-contentXS" textAlign="center">
				<BanjoString stringId={'information/error/linkBankUnsuccessful'} />
			</Text>
			<Text textStyle="bodyMediumStandard" className="mt-content2XS">
				<BanjoString stringId={'information/instruct/retrySoon'} />
			</Text>
			<Flex
				width="100%"
				justifyContent="center"
				className="my-contentMedium px-contentXS"
			>
				<ButtonStandard
					size="XL"
					variant="primary"
					onClick={() => {
						dismiss();
					}}
				>
					<BanjoString stringId={'action/progress/dismissMessage'} />
				</ButtonStandard>
			</Flex>
		</Flex>
	);
};

LinkPlaidTimeout.propTypes = {
	dismiss: PropTypes.func,
	trackEvent: PropTypes.func,
	isOnboarding: PropTypes.bool,
};

export default LinkPlaidTimeout;
